export function getNow(): Date {
    return new Date();
}
